export default __webpack_public_path__ + "static/media/favicon.94ddad5a.svg";